import { connect } from 'react-redux'
import { AppProvider } from '@toolpad/core/AppProvider';
import { SignInPage} from '@toolpad/core/SignInPage';
import {CookiesProvider, useCookies} from 'react-cookie'
import {onAuthorizeByTokenAction} from '../actions'

import { useForm } from '@mantine/form';
import { upperFirst, useToggle } from '@mantine/hooks';

import {
    Anchor,
    Button,
    Checkbox,
    Center,
    Group,
    Paper,
    PaperProps,
    PasswordInput,
    Stack,
    Text,
    TextInput,
  } from '@mantine/core';
  

const providers = [
    //{ id: 'google', name: 'Google' },
    { id: 'credentials', name: 'Email and Password' },
    
  ];
  const signIn = async (props, a) =>  {
    //console.log(a)

    /*if(provider.id == "google"){
        const authInstance = window.gapi.auth2;
        console.log(`Signing in with "${provider.name}, ${provider.id}`, authInstance)

    }
    else{ 
        //setCookie("user", "email")
        //console.log(`Signing in with "${provider.name}, ${provider.id}" and credentials: ${formData? formData.get('email'): "non"}, ${formData? formData.get('password'):"non"}`, window.gapi)
        props.onLoginAction(formData.get('email'), formData.get('password'), navigate)
        
    }*/

        //props.onAuthorizeByTokenAction(a.email, a.password, a.terms)

        const response = await fetch("/services/check/login", {
            method: "POST",
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "login": a.email,
                "password": a.password
            })
        });
        if(response.status === 200) { 
            const ret = await response.json();
            console.log("Authorize service addTask response:", ret);
            if(ret.user){
                const paramsString = window.location.search;
                const searchParams = new URLSearchParams(paramsString);
                const redirectRaw = searchParams.get("redirect_uri");

                if(redirectRaw){
                    const sep = redirectRaw.includes("?") ? "&" : "?";
                    const url = `${redirectRaw}${sep}user=${encodeURIComponent(JSON.stringify(ret.user))}`;
                    console.log(url)
                    window.location.replace(url);
                }
            }
        }
  }


  


let Authorize = (props)=> {
    const [setCookie] = useCookies(['user']);
    const [type, toggle] = useToggle(['login', 'register']);
    const form = useForm({
        initialValues: {
        email: '',
        name: '',
        password: '',
        terms: true,
        },

        validate: {
        email: (val) => (/^\S+@\S+$/.test(val) ? null : 'Invalid email'),
        password: (val) => (val.length <= 6 ? 'Password should include at least 6 characters' : null),
        },
    });

    return (
    <CookiesProvider>
     <div class="login">
        <div class="center">
            <div class="paper">
                <Center style={{color: "white"}}>
                    Welcome to Ifrit
                </Center>

                <form onSubmit={form.onSubmit((a) => {signIn(props, a)})}>
                    <Stack>
                    {type === 'register' && (
                        <TextInput
                        label="Name"
                        placeholder="Your name"
                        value={form.values.name}
                        onChange={(event) => form.setFieldValue('name', event.currentTarget.value)}
                        radius="md"
                        />
                    )}

                    <TextInput
                        required
                        label="Email"
                        placeholder="hello@mantine.dev"
                        value={form.values.email}
                        onChange={(event) => form.setFieldValue('email', event.currentTarget.value)}
                        error={form.errors.email && 'Invalid email'}
                        radius="md"
                    />

                    <PasswordInput
                        required
                        label="Password"
                        placeholder="Your password"
                        value={form.values.password}
                        onChange={(event) => form.setFieldValue('password', event.currentTarget.value)}
                        error={form.errors.password && 'Password should include at least 6 characters'}
                        radius="md"
                    />

                    {type === 'register' && (
                        <Checkbox
                        label="I accept terms and conditions"
                        checked={form.values.terms}
                        onChange={(event) => form.setFieldValue('terms', event.currentTarget.checked)}
                        />
                    )}
                    </Stack>

                    <Group justify="space-between" mt="xl">
                    <Anchor component="button" type="button" c="dimmed" onClick={() => toggle()} size="xs">
                        {type === 'register'
                        ? 'Already have an account? Login'
                        : "Don't have an account? Register"}
                    </Anchor>
                    <Button type="submit" radius="xl">
                        {upperFirst(type)}
                    </Button>
                    </Group>
                </form>
            </div>
        </div>
    </div>

    </CookiesProvider>
    )
    }


const mapDispatchToProps = {
    onAuthorizeByTokenAction: onAuthorizeByTokenAction
}

const mapStateToProps = (state) => {  
    return {
        "login": state ? state.login : null
    }
}


Authorize = connect(mapStateToProps, mapDispatchToProps)(Authorize);

export default Authorize;